import { router } from "@inertiajs/react"

type Visit = { method: string; url: URL }
type Location = { assign: (url: string) => void; reload: () => void }

// A page that isn't ours (Render or Cloudflare mid-deploy, a challenge, a
// static error page) would otherwise open Inertia's response modal. A GET is
// asked for again as a real page load so the browser shows whatever the server
// says; anything else may already have gone through, so the page is reloaded
// to show the true state rather than a stale one.
export function recoverFromBadResponse(visit: Visit | null, location: Location) {
  if (visit && visit.method === "get") {
    location.assign(visit.url.toString())
  } else {
    location.reload()
  }
}

export function installBadResponseRecovery(location: Location = window.location) {
  let current: Visit | null = null
  router.on("start", (event) => {
    current = { method: event.detail.visit.method, url: event.detail.visit.url }
  })
  router.on("httpException", (event) => {
    if ("x-inertia" in event.detail.response.headers) return
    recoverFromBadResponse(current, location)
    return false
  })
}
